/**
 * 滚动条滚动到指定位置动画
 * @param {DOM} el 滚动条所在元素
 */
export function scrollTop (el, from = 0, to, duration = 500) {
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame =
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function (callback) {
        return window.setTimeout(callback, 1000 / 60)
      }
  }
  const difference = Math.abs(from - to)
  const step = Math.ceil((difference / duration) * 50)

  function scroll (start, end, step) {
    if (start === end) return

    let d = start + step > end ? end : start + step
    if (start > end) {
      d = start - step < end ? end : start - step
    }

    if (el === window) {
      window.scrollTo(d, d)
    } else {
      el.scrollTop = d
    }
    window.requestAnimationFrame(() => scroll(d, end, step))
  }
  scroll(from, to, step)
}

export function assert (condition, msg) {
  if (!condition) throw new Error(`[Apior] ${msg}`)
}

export function parseQueryString (url) {
  url = url == null ? window.location.href : url
  if (url.lastIndexOf('?') === -1) {
    return {}
  }
  var search = url.substring(url.lastIndexOf('?') + 1)
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
    decodeURIComponent(
      search
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
    ) +
    '"}'
  )
  // return JSON.parse('{"' +decodeURIComponent(search).replace(/"/g,'\\"').replace(/&/g,'","').replace(/=/g,'":"') +'"}')
}

// 尝试执行方法
// fun 方法
// count 当fun出现异常之后，继续尝试次数，默认为1
// timer 失败后延迟毫秒后，再次执行，默认为1000
export function trydo (fun, count, timer) {
  count = count || 1
  timer = timer || 1000
  var _do = function () {
    try {
      if (count > 0) {
        fun.apply(this, arguments)
      }
    } catch (e) {
      count--
      setTimeout(_do, timer)
    }
  }
  _do()
}

// 问题 ：输入内容，软键盘弹出，页面内容整体上移，但是键盘收起，页面内容不下滑
//解决方案 ：固定定位的元素 在元素内 input 框聚焦的时候 弹出的软键盘占位 失去焦点的时候软键盘消失 但是还是占位的 导致input框不能再次输入 在失去焦点的时候给一个事件
// @blur.prevent="changeBlur"
export const changeBlur=() => {
  let u = navigator.userAgent//, app = navigator.appVersion
  let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  if(isIOS){
    setTimeout(() => {
      const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
      window.scrollTo(0, Math.max(scrollHeight - 1, 0))
    }, 200)
  }
}

//问题 ：安卓微信H5弹出软键盘后挡住input输入框，如下左图是期待唤起键盘的时候样子，右边是实际唤起键盘的样子
//解决方案 ：给input和textarea标签添加focus事件，如下，先判断是不是安卓手机下的操作，当然，可以不用判断机型，
//Document 对象属性和方法，setTimeout延时0.5秒，因为调用安卓键盘有一点迟钝，导致如果不延时处理的话，滚动就失效了
export const changefocus=() => {
  let u = navigator.userAgent//, app = navigator.appVersion;
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1
  if(isAndroid){
    setTimeout(function() {
      document.activeElement.scrollIntoViewIfNeeded()
      document.activeElement.scrollIntoView()
    }, 300)
  }
}

export const arrToMap=(arr,key) => {
  let map = {}
  arr.forEach((c) => {
    map[c[key]] = c
  })
  return map
}

function getNum (arg = '') {
  return Number(arg.toString().replace('.', ''))
}

function getDecimalLength(arg = ''){
  try {
    return arg.toString().split('.')[1].length
  } catch (e) {
    return 0
  }
}

export const divisionCount=(arg1, arg2) => {
  let t1, t2
  t1 = getDecimalLength(arg1)
  t2 = getDecimalLength(arg2)
  if (t1 - t2 > 0) {
    return getNum(arg1) / getNum(arg2) / Math.pow(10, t1 - t2)
  } else {
    return (getNum(arg1) / getNum(arg2)) * Math.pow(10, t2 - t1)
  }
}


const TRAIN_CARD_TYPE = [
  { key: '1', name: '身份证', row: 'idNumber' ,newKey:'NI'},
  { key: 'B', name: '护照', row: 'passport', periodRow: 'passportPeriod' ,issueRow:'passportDateOfIssue',newKey:'PP'},
  { key: 'C', name: '港澳居民来往内地通行证', row: 'otherNumber', periodRow: 'otherPeriod' ,issueRow:'otherDateOfIssue',newKey:'GA'},
  { key: 'G', name: '台湾居民来往大陆通行证', row: 'otherNumber', periodRow: 'otherPeriod',issueRow:'otherDateOfIssue' ,newKey:'TW'},
  { key: 'H', name: '外国人永久居留身份证', row: 'otherNumber', periodRow: 'otherPeriod',issueRow:'otherDateOfIssue' ,newKey:'FI'},
  { key: '2', name: '港澳台居民居住证', row: 'otherNumber', periodRow: 'otherPeriod' ,issueRow:'otherDateOfIssue',newKey:'HM'}
]

/**
 * 身份证类型
 * @desc 火车票新旧枚举类型对应
 */
export const TRAIN_NEW_TO_OLD=() => {
  return arrToMap(TRAIN_CARD_TYPE,'newKey')
}


export const invoiceErrCatch=(err) => {
  if(err.errCode == '239001' || err.errCode == '239003') {
    this.$toast.clear()
    this.smsCheckMsg = err.tips
    this.$dialog.alert({
      title: '温馨提示',
      message: '根据铁路局规定，你的账号需要先完成短信核验。',
      confirmButtonText: '去核验',
    }).then(async () => {
      this.$refs['verificate'].toggle()
    })

  } else if(err.errCode == '239002') {
    this.$toast.clear()
    this.$refs['face-detection'].toggle()
    console.log("需要人脸核验")

  }else if(err.errCode == '101' || err.errCode == '100') {
    console.log("登录授权失败 err catch"+err.tips)
  }else {
    console.log("获取发票抬头列表失败")
  }
}

// 完善第三方授权逻辑
export const AUTH_STATUS_KEY = "authStatus"
export async function waitForAuth(timeout) {
  return new Promise((resolve, reject) => {
    const startTime = Date.now()
    const interval = setInterval(() => {
      const status = localStorage.getItem(AUTH_STATUS_KEY)
      if (status === 'success') {
        clearInterval(interval)
        resolve()
      } else if (Date.now() - startTime > timeout) {
        clearInterval(interval)
        resolve()
      }
    }, 100)
  })
}
